var exports = {
  "P": "IconButton_0__V2ZcDz",
};

module.exports = exports;
